import Country from 'utils/country';

const getCountryMcc = (countryCode?: string | null) => {
  return Country.find((e) => e.iso === countryCode)?.iso;
};

export default getCountryMcc;
